import { Link } from 'react-router-dom';
import { COMICS } from '@/mocks/comics';

export default function LatestUpdates() {
  const latest = [...COMICS]
    .sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime())
    .slice(0, 8);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 max-w-7xl mx-auto">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950">最新更新</h2>
          <p className="text-sm text-foreground-500 mt-1">刚刚更新的韩漫章节</p>
        </div>
        <Link
          to="/category/all"
          className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap"
        >
          查看全部 <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
        {latest.map((comic) => {
          const latestChapter = comic.chapters[comic.chapters.length - 1];
          return (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group flex items-center gap-3 p-3 bg-background-50 border border-background-200 rounded-lg hover:border-primary-200 transition-all"
            >
              <div className="w-14 h-18 md:w-16 md:h-20 flex-shrink-0 overflow-hidden rounded-md">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  title={`${comic.title} - 韩国漫画网`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors truncate">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5 truncate">
                  {latestChapter.title}
                </p>
                <p className="text-xs text-foreground-400 mt-1">
                  {latestChapter.updatedAt}
                </p>
              </div>
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors flex-shrink-0">
                <i className="ri-arrow-right-s-line text-lg" />
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}